import { ReactNode } from 'react';

import { ICompanionModeExercise } from 'pages/big-screen/components/CompanionPlayer/types';

import { IWorkoutBlockExtended, IWorkoutExercisesBlockExtended } from 'types/personalPlan';

export type ExercisePlayerPropsTypes = WorkoutPaginationTypes & {
    currentExercise: IWorkoutExercisesBlockExtended;
    toNextExercise: () => void;
    toPrevExercise: () => void;
    onProgress: (id: number, progressData: ProgressDataType) => void;
    fancyProgressTime: ReactNode;
    handleCompleteWorkout: () => void;
    nextExerciseData: IWorkoutExercisesBlockExtended | undefined;
    prevExerciseData: IWorkoutExercisesBlockExtended;
    isNavigationLoading?: boolean;
    totalProgress: number;
};

export type ProgressDataType = {
    time: number;
    percents: number;
};

export type ProgressDataListType = {
    [key: string]: ProgressDataType;
};

export type WorkoutPaginationTypes<T = IWorkoutExercisesBlockExtended | ICompanionModeExercise> = {
    workoutExercises: T[];
    currentIndex: number;
    progress: ProgressDataListType;
    isWhiteMode?: boolean;
};

export type WorkoutNavigationBarTypes = {
    prevExercise: IWorkoutExercisesBlockExtended;
    nextExerciseData: IWorkoutExercisesBlockExtended | undefined;
    toPrevExercise: () => void;
    toNextExercise: () => void;
    isLoading?: boolean;
};

export type ExercisePlayerHeaderType = WorkoutPaginationTypes & {
    handlePlayButton: (isPlay: boolean) => void;
    handleCompleteWorkout: () => void;
    fancyProgressTime: ReactNode;
    totalProgress: number;
};

export type ExerciseItemType = {
    name: string;
    preview: string;
    time?: number;
    onClick?: () => void;
    isActive?: boolean;
};

export type ExerciseListType = {
    exercises: IWorkoutExercisesBlockExtended[];
    onClick?: (exercise: IWorkoutExercisesBlockExtended) => void;
    activeExercise?: number;
};

export type WorkoutExercisesListTypes = {
    blocks: IWorkoutBlockExtended[];
    onClick?: (exercise: IWorkoutExercisesBlockExtended) => void;
    activeExerciseId?: number;
    exercises?: IWorkoutExercisesBlockExtended[];
};

export enum WorkoutState {
    completed = 'completed',
    availableNow = 'availableNow',
    notAvailable = 'notAvailable',
}
